import * as devConfig from "../../../app/configs/devConfig";
import { getAuthHeader } from "../../../app/globalState/GlobalAuthState";

/**
 * Downloads one attachment of the signed-in person's mailbox through the
 * ProCharted server (`api/emails/attachment-file`), so the browser never
 * needs the mailbox provider's key. Returns a local link for the preview.
 */
export const fetchAttachmentFile = async ({
  userId,
  messageId,
  attachmentId,
  fileName,
}: {
  userId: string;
  messageId: string;
  attachmentId: string;
  fileName: string;
}): Promise<string> => {
  const params = new URLSearchParams({
    userId,
    messageId,
    attachmentId,
    fileName,
  });
  const response = await fetch(
    `${devConfig.getServerBaseUrlForEnv()}/api/emails/attachment-file?${params.toString()}`,
    { headers: { Authorization: getAuthHeader().Authorization } },
  );
  if (!response.ok) throw new Error("download failed");
  return URL.createObjectURL(await response.blob());
};
